import gql from "graphql-tag";

export const COMPLETE_MANUAL_INTERVENTION = gql`
	mutation CompleteManualIntervention(
		$input: CompleteManualInterventionInput!
	) {
		completeManualIntervention(input: $input) {
			boolean
		}
	}
`;
